import { FINANCE_ROUTE, HOME_ROUTE } from '../../app/router/routes'
import { useAppSelector } from '../../app/store/store'
import { FinanceWidget, StaffPenaltiesBonuses } from '../../widgets/finance'
import { LayoutPages } from '../layoutPages'
import { FEATURES, FEATURE_SECTIONS, hasFeature, hasFeatureGrant } from '../../entities/my'
import { Navigate } from 'react-router-dom'
import { TutorSalaries } from '../../widgets/tutorSalaries'
import { WorkerPayroll } from '../../widgets/workerPayroll'
import classes from './finance.module.scss'
import { AdminDownloadTutors } from '../../widgets/adminDownloadTutors'
import { AdminTransactions } from '../../widgets/adminTransactions'
import { SurfaceBlock } from '../../shared/ui/surfaceBlock'
import { OpenContainer } from '../../features/openContainer'

export default function FinancePage() {

    const {my} = useAppSelector(s => s.myReducer)
    const canViewFullFinance = hasFeature(my, FEATURES.FINANCE.VIEW_FULL)
    const canViewPartialFinance = hasFeature(my, FEATURES.FINANCE.VIEW_PARTIAL)
    const canViewDocuments = hasFeatureGrant(my, FEATURES.DOCUMENTS.VIEW)
    const canViewStaffPenaltiesBonuses = hasFeature(my, FEATURES.BILLING.PENALTIES_BONUSES_VISIBLE_READ)
    const canViewWorkerPayroll = hasFeatureGrant(my, FEATURES.IDM.STAFF_ACCRUALS_READ)
    const isAccess = hasFeature(my, FEATURE_SECTIONS.FINANCE)
    
    if(!isAccess){
        return (
            <Navigate to={HOME_ROUTE.path} replace />
        )
    }

    return (
        <LayoutPages title={FINANCE_ROUTE.name}>
            <section className={classes.container}>
                {(canViewFullFinance || canViewPartialFinance) && <SurfaceBlock className={classes.finance + ` ${classes.data}`}>
                    <OpenContainer
                        title="Финансы"
                        allowOverflow
                        icon={<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 20V11M10 20V4M16 20V8M22 20V2" /></svg>}
                    >
                        <FinanceWidget />
                    </OpenContainer>
                </SurfaceBlock>}
                {canViewDocuments && <SurfaceBlock className={classes.archivesBlock}>
                    <AdminDownloadTutors />
                </SurfaceBlock>}
                {
                    hasFeature(my, FEATURES.FRONT.SALARY)
                        &&
                    <SurfaceBlock className={`${classes.finance} ${classes.fullWidth} ${classes.salariesBlock}`}>
                        <TutorSalaries />
                    </SurfaceBlock>
                }
                {canViewWorkerPayroll && (
                    <SurfaceBlock className={`${classes.finance} ${classes.fullWidth} ${classes.salariesBlock}`}>
                        <WorkerPayroll />
                    </SurfaceBlock>
                )}
                {
                    hasFeatureGrant(my, FEATURES.TRANSACTIONS.LIST)
                        &&
                    <SurfaceBlock className={`${classes.finance} ${classes.fullWidth} ${classes.transactionsBlock}`}>
                        <OpenContainer
                            title="Транзакции"
                            allowOverflow
                            icon={<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 7H18L15 4M20 17H6L9 20" /><path d="M18 7L20 7L20 12M6 17L4 17L4 12" /></svg>}
                        >
                            <AdminTransactions embedded />
                        </OpenContainer>
                    </SurfaceBlock>
                }
                {canViewStaffPenaltiesBonuses && <StaffPenaltiesBonuses />}
            </section>
        </LayoutPages>
    )
}
